var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-date-time"},[_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm._f("toFormattedDate")(_vm.gameDateTime,'d-MMM-yyyy - HH:mm')))]),_vm._v(" HRS ")])
}
var staticRenderFns = []

export { render, staticRenderFns }